// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * @shapeshiftoss/solana-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 10.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Account,
  BadRequestError,
  BaseInfo,
  BaseTxHistoryTx,
  DoRpcRequest200Response,
  DoRpcRequestRequest,
  EstimateFeesBody,
  InternalServerError,
  PriorityFees,
  SendTxBody,
  TokenDetails,
  Tx,
  ValidationError,
} from '../models';
import {
    AccountFromJSON,
    AccountToJSON,
    BadRequestErrorFromJSON,
    BadRequestErrorToJSON,
    BaseInfoFromJSON,
    BaseInfoToJSON,
    BaseTxHistoryTxFromJSON,
    BaseTxHistoryTxToJSON,
    DoRpcRequest200ResponseFromJSON,
    DoRpcRequest200ResponseToJSON,
    DoRpcRequestRequestFromJSON,
    DoRpcRequestRequestToJSON,
    EstimateFeesBodyFromJSON,
    EstimateFeesBodyToJSON,
    InternalServerErrorFromJSON,
    InternalServerErrorToJSON,
    PriorityFeesFromJSON,
    PriorityFeesToJSON,
    SendTxBodyFromJSON,
    SendTxBodyToJSON,
    TokenDetailsFromJSON,
    TokenDetailsToJSON,
    TxFromJSON,
    TxToJSON,
    ValidationErrorFromJSON,
    ValidationErrorToJSON,
} from '../models';

export interface DoRpcRequestOperationRequest {
    doRpcRequestRequest: DoRpcRequestRequest;
}

export interface EstimateFeesRequest {
    estimateFeesBody: EstimateFeesBody;
}

export interface GetAccountRequest {
    pubkey: string;
}

export interface GetTokenRequest {
    id: string;
}

export interface GetTransactionRequest {
    txid: string;
}

export interface GetTxHistoryRequest {
    pubkey: string;
    cursor?: string;
    pageSize?: number;
}

export interface SendTxRequest {
    sendTxBody: SendTxBody;
}

/**
 * 
 */
export class V1Api extends runtime.BaseAPI {

    /**
     * Makes a jsonrpc request to the node.
     */
    async doRpcRequestRaw(requestParameters: DoRpcRequestOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DoRpcRequest200Response>> {
        if (requestParameters.doRpcRequestRequest === null || requestParameters.doRpcRequestRequest === undefined) {
            throw new runtime.RequiredError('doRpcRequestRequest','Required parameter requestParameters.doRpcRequestRequest was null or undefined when calling doRpcRequest.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/jsonrpc`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DoRpcRequestRequestToJSON(requestParameters.doRpcRequestRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DoRpcRequest200ResponseFromJSON(jsonValue));
    }

    /**
     * Makes a jsonrpc request to the node.
     */
    async doRpcRequest(requestParameters: DoRpcRequestOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DoRpcRequest200Response> {
        const response = await this.doRpcRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the estimated compute unit cost of a transaction
     */
    async estimateFeesRaw(requestParameters: EstimateFeesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.estimateFeesBody === null || requestParameters.estimateFeesBody === undefined) {
            throw new runtime.RequiredError('estimateFeesBody','Required parameter requestParameters.estimateFeesBody was null or undefined when calling estimateFees.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/fees/estimate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EstimateFeesBodyToJSON(requestParameters.estimateFeesBody),
        }, initOverrides);

        return new runtime.JSONApiResponse(response) as any;
    }

    /**
     * Get the estimated compute unit cost of a transaction
     */
    async estimateFees(requestParameters: EstimateFeesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.estimateFeesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get account details by address or extended public key
     */
    async getAccountRaw(requestParameters: GetAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Account>> {
        if (requestParameters.pubkey === null || requestParameters.pubkey === undefined) {
            throw new runtime.RequiredError('pubkey','Required parameter requestParameters.pubkey was null or undefined when calling getAccount.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/account/{pubkey}`.replace(`{${"pubkey"}}`, encodeURIComponent(String(requestParameters.pubkey))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AccountFromJSON(jsonValue));
    }

    /**
     * Get account details by address or extended public key
     */
    async getAccount(requestParameters: GetAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Account> {
        const response = await this.getAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get information about the running coinstack
     */
    async getInfoRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BaseInfo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/info`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BaseInfoFromJSON(jsonValue));
    }

    /**
     * Get information about the running coinstack
     */
    async getInfo(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BaseInfo> {
        const response = await this.getInfoRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get the current recommended priority fees for a transaction to land
     */
    async getPriorityFeesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PriorityFees>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/fees/priority`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PriorityFeesFromJSON(jsonValue));
    }

    /**
     * Get the current recommended priority fees for a transaction to land
     */
    async getPriorityFees(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PriorityFees> {
        const response = await this.getPriorityFeesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get token details
     */
    async getTokenRaw(requestParameters: GetTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TokenDetails>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getToken.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/token/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TokenDetailsFromJSON(jsonValue));
    }

    /**
     * Get token details
     */
    async getToken(requestParameters: GetTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TokenDetails> {
        const response = await this.getTokenRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get transaction details
     */
    async getTransactionRaw(requestParameters: GetTransactionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Tx>> {
        if (requestParameters.txid === null || requestParameters.txid === undefined) {
            throw new runtime.RequiredError('txid','Required parameter requestParameters.txid was null or undefined when calling getTransaction.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/tx/{txid}`.replace(`{${"txid"}}`, encodeURIComponent(String(requestParameters.txid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TxFromJSON(jsonValue));
    }

    /**
     * Get transaction details
     */
    async getTransaction(requestParameters: GetTransactionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Tx> {
        const response = await this.getTransactionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get transaction history by address
     */
    async getTxHistoryRaw(requestParameters: GetTxHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BaseTxHistoryTx>> {
        if (requestParameters.pubkey === null || requestParameters.pubkey === undefined) {
            throw new runtime.RequiredError('pubkey','Required parameter requestParameters.pubkey was null or undefined when calling getTxHistory.');
        }

        const queryParameters: any = {};

        if (requestParameters.cursor !== undefined) {
            queryParameters['cursor'] = requestParameters.cursor;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/account/{pubkey}/txs`.replace(`{${"pubkey"}}`, encodeURIComponent(String(requestParameters.pubkey))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BaseTxHistoryTxFromJSON(jsonValue));
    }

    /**
     * Get transaction history by address
     */
    async getTxHistory(requestParameters: GetTxHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BaseTxHistoryTx> {
        const response = await this.getTxHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Sends raw transaction to be broadcast to the node.
     */
    async sendTxRaw(requestParameters: SendTxRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.sendTxBody === null || requestParameters.sendTxBody === undefined) {
            throw new runtime.RequiredError('sendTxBody','Required parameter requestParameters.sendTxBody was null or undefined when calling sendTx.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/send`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SendTxBodyToJSON(requestParameters.sendTxBody),
        }, initOverrides);

        return new runtime.JSONApiResponse(response) as any;
    }

    /**
     * Sends raw transaction to be broadcast to the node.
     */
    async sendTx(requestParameters: SendTxRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.sendTxRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
